module.exports = __webpack_public_path__ + "static/media/ic-ebike-small.8b6908b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-ebike-small.svg
// module id = 623
// module chunks = 14